/**
 * Centralized PII scrubbing utilities.
 *
 * Used by both Datadog RUM (beforeSend) and Apollo error logging to ensure
 * consistent redaction across all telemetry surfaces.
 */

const EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi;

/** Replace all email-like substrings in `text` with `[REDACTED]`. */
export const scrubEmails = (text: string): string => text.replace(EMAIL_PATTERN, '[REDACTED]');
